import { render } from "./addTodo.vue?vue&type=template&id=7be96262&scoped=true"
import script from "./addTodo.vue?vue&type=script&lang=js"
export * from "./addTodo.vue?vue&type=script&lang=js"

import "./addTodo.vue?vue&type=style&index=0&id=7be96262&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ad\\Downloads\\internship-project-todolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be96262"]])

export default __exports__